/* eslint-disable no-param-reassign */
import { PayloadAction } from "@reduxjs/toolkit"

import { BuildingReferenceReducerState } from "./buildingReferenceSlice"

export function setActiveProductFiltersHandler(
  state: BuildingReferenceReducerState,
  action: PayloadAction<{
    buildingReferenceID: string
    activeProductFilters: string[]
  }>
) {
  if (!state[action.payload.buildingReferenceID]) {
    state[action.payload.buildingReferenceID] = {
      activeProductFilters: []
    }
  }

  state[action.payload.buildingReferenceID].activeProductFilters =
    action.payload.activeProductFilters
}
